/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_DeclineInputs */

const en_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const de_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

const fr_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuser`)
};

const es_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar`)
};

const it_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiuta`)
};

const nl_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weigeren`)
};

const pl_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzuc`)
};

const fi_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylkaa`)
};

const da_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvis`)
};

const sv_cookie_consent_decline = /** @type {(inputs: Cookie_Consent_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neka`)
};

/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Cookie_Consent_DeclineInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_decline = /** @type {((inputs?: Cookie_Consent_DeclineInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_DeclineInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_decline(inputs)
	if (locale === "fr") return fr_cookie_consent_decline(inputs)
	if (locale === "es") return es_cookie_consent_decline(inputs)
	if (locale === "it") return it_cookie_consent_decline(inputs)
	if (locale === "nl") return nl_cookie_consent_decline(inputs)
	if (locale === "pl") return pl_cookie_consent_decline(inputs)
	if (locale === "fi") return fi_cookie_consent_decline(inputs)
	if (locale === "da") return da_cookie_consent_decline(inputs)
	if (locale === "sv") return sv_cookie_consent_decline(inputs)
	return en_cookie_consent_decline(inputs)
});